import Styles from './LayerActions.module.scss'
import { Button } from 'components/Button/Button'
import { ReactComponent as DeleteIcon } from './delete16.svg'
import { ReactComponent as MergeIcon } from './merge16.svg'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { ConditionalWrapper } from 'common/ConditionalWrapper/ConditionalWrapper'
import { Tooltip } from 'components/Tooltip/Tooltip'

export const LayerActions = observer(() => {
  const rootStore = useRootStore()
  const docStore = rootStore.docStore

  if (!docStore) {
    return null
  }

  const { acceptAll, rejectAll, changesCount, canAcceptChanges } = docStore.trackedChangesStore

  const handleMergeAll = () => {
    acceptAll()
    docStore.cleanupModeStore.resolveAllComments()
  }

  const handleDeleteAll = () => {
    rejectAll()
    docStore.cleanupModeStore.destroyAllComments()
  }

  const hasOutstandingItems = docStore.cleanupModeStore.commentsForCleanup.length + changesCount > 0

  return (
    <div className={Styles.actions}>
      <span className={Styles.buttonWrapper}>
        <Button
          variant="secondaryGrey"
          size="md"
          onPress={handleDeleteAll}
          isDisabled={!hasOutstandingItems}
          frontIcon={DeleteIcon}
          className={Styles.button}
          iconClassName={Styles.deleteIcon}
        >
          Delete All
        </Button>
      </span>
      <ConditionalWrapper
        condition={!canAcceptChanges}
        wrapper={(children) => (
          <Tooltip label="You don't have edit access to accept">
            <span className={Styles.buttonWrapper}>{children}</span>
          </Tooltip>
        )}
      >
        <Button
          variant="secondaryGrey"
          size="md"
          onPress={handleMergeAll}
          isDisabled={!hasOutstandingItems || !canAcceptChanges}
          frontIcon={MergeIcon}
          className={Styles.button}
          iconClassName={Styles.mergeIcon}
        >
          Merge All
        </Button>
      </ConditionalWrapper>
    </div>
  )
})
